import React from "react";
import { TopNavLanguageSelector } from "./TopNav/TopNavLanguageSelector";
import TopNavLink from "./TopNav/TopNavLink";
import TopNavSearch from "./TopNav/TopNavSearch";
import * as styles from "./TopMenu.module.scss";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import {
  ValidatedTopMenuItem,
  ValidatedTopMenuItemSpecialType
} from "../utils";
import { AlternateLink } from "src/utils/localization/alternateLinks";
import LightPhoneNumber from "../PhoneNumber/LightPhoneNumber";

type Props = {
  searchUrl: string | undefined;
  topLinks: ValidatedTopMenuItem[];
  alternateLinks: AlternateLink[];
  forceShowLinks?: ValidatedTopMenuItemSpecialType[] | undefined;
};

const TopMenu: React.FC<Props> = ({
  searchUrl,
  alternateLinks,
  topLinks,
  forceShowLinks = []
}) => {
  const language = useLanguage();
  const mySilversea = topLinks.find((l) => l.specialType === "my-silversea");
  const linksWithoutMySilversea = topLinks.filter(
    (l) => l.specialType !== "my-silversea"
  );

  return (
    <nav
      className={styles.header}
      aria-label="Secondary menu"
      data-content-name="secondary_menu"
    >
      <div className={styles.headerContainer}>
        <div>
          <LightPhoneNumber />
        </div>

        {linksWithoutMySilversea && linksWithoutMySilversea.length > 0 && (
          <ul className={styles.links}>
            <React.Fragment>
              {linksWithoutMySilversea.map((l) => (
                <li
                  key={l._key}
                  data-link-force-show={
                    l.specialType
                      ? forceShowLinks.includes(l.specialType)
                      : undefined
                  }
                >
                  <TopNavLink renderAs="link" {...l} />
                </li>
              ))}
            </React.Fragment>

            <li className={styles.separator} aria-hidden>
              <hr />
            </li>

            <li>
              <TopNavLanguageSelector
                currentLanguage={language}
                alternateLinks={alternateLinks}
              />
            </li>

            {searchUrl && (
              <li>
                <TopNavSearch searchUrl={searchUrl} />
              </li>
            )}

            {mySilversea && (
              <li>
                <TopNavLink
                  renderAs="link"
                  {...mySilversea}
                  iconName="user"
                  iconStrokeWidth={1}
                />
              </li>
            )}
          </ul>
        )}
      </div>
    </nav>
  );
};

export default TopMenu;
